<template>
  <MBaseDialog :isVisible="isVisible">
    <template #content>
      <div class="alert-content" v-html="message"></div>
    </template>
    <template #actions>
      <AButton @click="hideAlert" class="btn-chk">확인</AButton>
    </template>
  </MBaseDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AButton } from '@atoms';
import { useAlertStore } from '@stores';
import { MBaseDialog } from '@molecules';

const alertStore = useAlertStore();

const isVisible = computed(() => alertStore.isAlertVisible);
const message = computed(() => alertStore.message);

const hideAlert = () => {
  alertStore.hideAlertDialog();
};
</script>

<style scoped lang="scss">
.alert-content {
  @apply text-center;
  font-size: clamp(1.125rem, 1.1rem + 0.125vw, 1.25rem);
  line-height: clamp(1.5625rem, 1.3125rem + 1.25vw, 2.8125rem);
  word-break: keep-all;
  padding: 0 16px;
}

.btn-chk {
  background: var(--btn-color);
  border-radius: 20px 0 20px 1px;
  font-size: clamp(1rem, 0.975rem + 0.125vw, 1.125rem);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 160px;
  margin: 40px auto 0;
  padding: 13px 0;
  font-weight: 300;
}

/*모바일*/
@media (min-width: 320px) and (max-width: 1279px) {
  .alert-content {
    font-size: 1rem;
  }

  .btn-chk {
    font-size: 0.88rem;
    margin: 20px auto 0;
  }
}
</style>
